import * as React from "react";
import { forwardRef } from "react";
const SvgError = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 8a8 8 0 1 1 8 8 8.01 8.01 0 0 1-8-8m2 0a6 6 0 1 0 12 0A6 6 0 0 0 2 8m7.413 2.829L8 9.414l-1.414 1.414a1 1 0 0 1-1.415-1.414L6.586 8 5.171 6.586a1 1 0 1 1 1.415-1.414L8 6.586l1.414-1.414a1 1 0 1 1 1.415 1.414L9.415 8l1.414 1.415a1 1 0 0 1-1.415 1.414z" }));
const ForwardRef = forwardRef(SvgError);
export { ForwardRef as ReactComponent };
